import {ComponentType} from './component-type.enum';
import {TemplateDeliveryPath} from './template-delivery-path';
import {TemplateComponentContent} from './template-component-content';
import {Template} from './template';
import {ProductLine} from './product-line.enum';

export class TemplateComponent {
  constructor(
    public id: number,
    public name?: string,
    public displayLabel?: string,
    public productLine?: ProductLine,
    public componentType?: ComponentType,
    public deliveryPath?: TemplateDeliveryPath,
    public contents?: Array<TemplateComponentContent>,
    public templates?: Array<Template>
  ) {
    this.contents = [];
    this.templates = [];
  }
}
